import { checkRequest, getStore } from 'utils/utils'
import loadMenu from 'utils/api/loadMenu/loadMenu'
import Session from 'mobx/Session'

const setMenuUrl = (url: string) => localStorage.setItem('menuUrl', url)

const getMenuUrl = () => localStorage.getItem('menuUrl')

const deleteMenuUrl = () => localStorage.removeItem('menuUrl')

const getStoreId = () => localStorage.getItem('storeId')

const handleCheckRequest = ({
	request,
	cust,
	storeId,
}: {
	request: string
	cust: string
	storeId: string
}) =>
	checkRequest({
		request,
		cust,
		j: storeId,
	})

const handleLoadMenu = ({
	chainId,
	storeId,
	orderTypeFromQS,
	appId,
	stopLoading,
}: {
	chainId: string
	storeId: string
	orderTypeFromQS: string
	appId: number
	stopLoading: boolean
}) =>
	loadMenu({
		chainId,
		storeId,
		orderTypeFromQS,
		appId,
		stopLoading,
	})

const handleGetStore = ({
	request,
	cust,
}: {
	request: string
	cust: string
}) =>
	getStore({
		request,
		cust,
	})

const handleInitNewSession = ({
	ref,
	storeId,
	pc,
	stopLoading = false,
}: {
	ref: string
	storeId: string
	pc: string
	stopLoading: boolean
}) => {
	let refObject = {}
	try {
		const refDecodedString = decodeURIComponent(ref)
		refObject = JSON.parse(refDecodedString)
	} catch (err) {}
	return Session.initOrUpdateSession({ refObject, storeId, chainId: pc, stopLoading })
}

export default {
	setMenuUrl,
	getMenuUrl,
	getStoreId,
	deleteMenuUrl,
	handleCheckRequest,
	handleGetStore,
	handleLoadMenu,
	handleInitNewSession,
}
